<div *ngIf="ifCondition" class="p-p-4 p-ai-center p-d-flex p-my-3" style="background: #fff2e2; border-left: solid #cc8925;border-radius: 6px;">
    <span class="pi pi-exclamation-triangle p-mr-3" style="font-size: 1.5rem; color:#cc8925;"></span>
    <span style="color:#cc8925">{{message}}</span>
</div>